/** Path prefix for the live, embeddable Genie experience (EmbedLiveAgentExperience,
 * rendered by LiveAgentPage when ?embed=true). Centralized so the URL shape can
 * change in one place instead of being rebuilt at every call site. */
const EMBED_BASE_PATH = "/live-agent";

export const buildEmbedPath = (urlName: string): string =>
  `${EMBED_BASE_PATH}/${encodeURIComponent(urlName)}?embed=true`;

export const buildEmbedUrl = (origin: string, urlName: string): string =>
  `${origin}${buildEmbedPath(urlName)}`;
